/**
 * FeatureRetired — sentinel page for routes whose module has been
 * feature-flagged off. Shown at /app/options, /app/shorts, /app/bonds,
 * /app/expert while the corresponding FEATURE_* env flag is `false`.
 *
 * Copy is intentionally kind: the platform's focus is now the Live Overlay
 * architecture, and the retired modules can be brought back at any point
 * by flipping their env flag (see backend/services/feature_flags.py).
 */
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, PackageOpen } from "lucide-react";

export default function FeatureRetired({ module, replacement }) {
    return (
        <div className="max-w-2xl mx-auto p-8 space-y-4" data-testid={`feature-retired-${module}`}>
            <div className="flex items-center gap-2 text-muted-foreground">
                <PackageOpen className="w-4 h-4" /> Feature retired
            </div>
            <h1 className="text-2xl font-bold">{module}</h1>
            <p className="text-sm text-muted-foreground">
                As of February 2026, {module} is no longer available on Melian
                Dialogue. The platform has consolidated around the Live Overlay
                trading architecture — live market rates with simulated
                execution capital. {replacement && (
                    <>Try <span className="text-foreground font-medium">{replacement}</span> instead.</>
                )}
            </p>
            <div className="flex gap-2">
                <Link to="/app/terminal">
                    <Button data-testid="feature-retired-cta-terminal">
                        Open the Terminal <ArrowRight className="w-4 h-4 ml-1" />
                    </Button>
                </Link>
                <Link to="/app/macro">
                    <Button variant="outline" data-testid="feature-retired-cta-macro">
                        Macro dashboard
                    </Button>
                </Link>
            </div>
        </div>
    );
}
